import React, { useState } from 'react';
import PropTypes           from 'prop-types';
import PreviewDropzone     from '~/../components/communities_manage/components/preview_dropzone';
import { isEmpty }         from 'lodash';
import TagInput            from '~/../components/shared/components/tag_input';

const SetupCommunity = ({ formData, handleFieldChange, files, handleSetFile }) => {
  const [industries, setIndustries] = useState(
    isEmpty(formData.industries) ? [] : formData.industries?.split(',')
  );

  const handleTagsChange = (name, tags) => {
    setIndustries(tags);
    handleFieldChange({ target: { name, value: tags.join(', ') } });
  }

  return (
    <div className='ml-20'>
      <p className='fs-23 w3'>Get your community started</p>

      <label className='fs-15 w3 mt-50 block mb-5'>Community profile photo</label>
      <div className='clear onboarding-image'>
        <PreviewDropzone
          files={files}
          setFiles={handleSetFile}
          imgUrl={formData.image_url}
          className='block'
        />
        <div className='onboarding-image-label ib'>
          <small>Drag & drop or click to add image</small>
          <small className='block'>JPEG or PNG, no larger than 5MB</small>
        </div>
      </div>

      <label className='fs-15 w3 mt-20 block mb-5'>Description</label>
      <textarea
        className='fs-15 form-control mw-70r'
        rows='6'
        draggable='false'
        name='description'
        value={formData.description || ''}
        onChange={handleFieldChange}
      />

      <label className='fs-15 w3 mt-20 block mb-5'>Industries</label>
      <TagInput
        placeholder='Type the industry name and press ENTER to confirm...'
        styles={'mt-5 mw-70r'}
        onChange={tags => handleTagsChange('industries', tags)}
        value={industries}
      />

      <label className='fs-15 w3 mt-20 block mb-5'>Rules & Expectations</label>
      <textarea
        className='fs-15 form-control mw-70r'
        rows='6'
        draggable='false'
        name='rules'
        value={formData.rules || ''}
        onChange={handleFieldChange}
      />
    </div>
  );
};

SetupCommunity.propTypes = {
  formData: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
  files: PropTypes.array,
  handleSetFile: PropTypes.func.isRequired
};

export default SetupCommunity;
